/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/infonew'>.
 * из e2e исключён как невалидный, роут сохранён
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import SmsLanding from '@routes/SmsLanding';

export const Route = createFileRoute('/infonew')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={SmsLanding} path='/infonew' />
  )
});
